
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { PriceCategory } from "@/types/priceCategory";

interface PriceCategoriesTableProps {
  categories: PriceCategory[];
  onEdit: (category: PriceCategory) => void;
}

export function PriceCategoriesTable({ categories, onEdit }: PriceCategoriesTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow className="bg-muted/50">
            <TableHead className="w-[100px]">Prefixo</TableHead>
            <TableHead className="w-[250px]">Grupo</TableHead>
            <TableHead className="w-[150px]">Tipo</TableHead>
            <TableHead className="w-[150px]">Preço Fixo ($)</TableHead>
            <TableHead className="w-[200px]">Faixa de Preço ($)</TableHead>
            <TableHead className="w-[100px] text-right">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {categories.map((category) => (
            <TableRow key={category.id}>
              <TableCell className="font-mono">{category.prefix}</TableCell>
              <TableCell className="font-medium">{category.name}</TableCell>
              <TableCell>
                <Badge
                  variant={category.price_type === 'fixed' ? 'default' : 'secondary'}
                >
                  {category.price_type === 'fixed' ? 'Fixo' : 'Faixa'}
                </Badge>
              </TableCell>
              <TableCell>
                {category.price_type === 'fixed' && category.fixed_price
                  ? `$${category.fixed_price.toFixed(2)}`
                  : '-'}
              </TableCell>
              <TableCell>
                {category.price_type === 'range' && category.min_price && category.max_price
                  ? `$${category.min_price.toFixed(2)} - $${category.max_price.toFixed(2)}`
                  : '-'}
              </TableCell>
              <TableCell className="text-right">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onEdit(category)}
                >
                  <Pencil className="h-4 w-4 mr-1" />
                  Editar
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
